import React, { memo, useEffect, useState } from "react";
import { Modal, Table, Button, InputGroup } from "react-bootstrap";
import { Col, Row, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  empCertificateLeft,
  empCertificateRight,
  taxIncomeService,
} from "common/StringUtils.js";
import { dataTable } from "common/FunctionUtils.js";
import { toast } from "react-toastify";
import axios from "axios";
import { LOCALES } from "common/constants";
import Loader from "../../../../components/Loader";

const DownloadCertificateModal = ({
  pdfDownloadData,
  toggleDownload,
  settoggleDownload,
}) => {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState("");
  const [endDate, setendDate] = useState("");
  const [referYear, setreferYear] = useState("");
  const [firstYearDataTable, setfirstYearDataTable] = useState(dataTable());
  const [secondYearDataTable, setsecondYearDataTable] = useState(dataTable());
  const [selectedLanguage, setSelectedLanguage] = useState("sv-se");
  const [incomeServiceFields, setincomeServiceFields] =
    useState(taxIncomeService);
  const [isLoading, setisLoading] = useState(false);
  const language = localStorage.getItem("i18nextLng");

  const formatMonthYear = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${year}`;
  };

  const handleDownloadPDF = async () => {
    setisLoading(true); // Show loader
    try {
      const { firstName, lastName } = pdfDownloadData;
      const date = new Date().toISOString().split("T")[0];
      const URL = `/employeecertificate/${
        pdfDownloadData?.certificateId
      }/download?locale=${selectedLanguage}`;

      // Request the PDF file as a Blob
      const result = await axios.get(URL, { responseType: "blob" });

      if (result?.status === 200) {
        const blob = new Blob([result.data], { type: "application/pdf" });
        const downloadUrl = window.URL.createObjectURL(blob);

        const downloadLink = document.createElement("a");
        downloadLink.href = downloadUrl;
        downloadLink.download = `Employer certificate ${firstName} ${lastName} ${date}.pdf`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        window.URL.revokeObjectURL(downloadUrl);
      }
    } catch (err) {
      const { certificateId } = pdfDownloadData;
      if(err?.response?.status === 404){
        toast.error(`${t(`Certificate with id`)} ${certificateId} ${t(`not found.`)}`);

      }
    } finally {
      setisLoading(false); // Hide loader
      settoggleDownload(false);
    }
  };

  useEffect(() => {
    if (pdfDownloadData?.employeeWagesDetails) {
      const filterDate = pdfDownloadData?.employeeWagesDetails?.filter(
        (f) =>
          new Date(f.hoursDate).getFullYear() ===
          new Date(pdfDownloadData?.reportedTimeFromDate).getFullYear()
      );

      const prefillData = dataTable(filterDate);
      const filterDate1 = pdfDownloadData?.employeeWagesDetails?.filter(
        (f) =>
          new Date(f.hoursDate).getFullYear() ===
          new Date(pdfDownloadData?.reportedTimeEndDate).getFullYear()
      );
      const prefillData1 = dataTable(filterDate1);

      setfirstYearDataTable(prefillData);
      setsecondYearDataTable(prefillData1);
    }
  }, [pdfDownloadData?.employeeWagesDetails]);

  useEffect(() => {
    if (pdfDownloadData?.certificateDetailsPerMonth) {
      const updatedIncomeServiceFields = taxIncomeService.map((item, index) => {
        const certificateDetailsPerMonthItem =
          pdfDownloadData?.certificateDetailsPerMonth[index];
        if (certificateDetailsPerMonthItem) {
          return {
            ...certificateDetailsPerMonthItem,
            monthdate: certificateDetailsPerMonthItem.monthdate?.split("T")[0],
          };
        }
        return item;
      });
      const filledValues = updatedIncomeServiceFields.filter((item) => {
        const values = Object.values(item);
        return values.some((value) => value !== "");
      });
      const remainingCount = 13 - filledValues.length;
      const finalIncomeServiceFields = [
        ...filledValues,
        ...Array(remainingCount).fill({
          monthdate: "",
          numberOfDaysWorked: "",
          dutyHours: "",
          nokMonth: "",
          otherRemunerationEnterArt: "",
          nokMonthAmount: "",
        }),
      ];
      setincomeServiceFields(finalIncomeServiceFields);
    }
  }, [pdfDownloadData?.certificateDetailsPerMonth]);

  useEffect(() => {
    if (pdfDownloadData?.reportedTimeFromDate) {
      const date = new Date(pdfDownloadData.reportedTimeFromDate);
      setStartDate(date.getFullYear());
    }
    if (pdfDownloadData?.reportedTimeEndDate) {
      const date = new Date(pdfDownloadData.reportedTimeEndDate);
      setendDate(date.getFullYear());
    }

    if (pdfDownloadData?.salaryRefers) {
      const date = new Date(pdfDownloadData.salaryRefers);
      setreferYear(date.getFullYear());
    }
  }, [pdfDownloadData]);

  return (
    <React.Fragment>
       {isLoading ? (
          <div style={{ minHeight: 400, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Loader />
          </div>
        ) : (
      <Modal
        key={pdfDownloadData?.certificateId}
        size="lg"
        aria-labelledby="example-modal-sizes-title-lg"
        show={toggleDownload}
        onHide={() => {
          settoggleDownload(false);
        }}
        animation={true}
        className="Apply_certificate fade.Apply_certificate.modal"
      >
        <div id="save_certificate">
          <Modal.Header closeButton>
            <Modal.Title>{t("Employer certificate")}</Modal.Title>
          </Modal.Header>

          {/* 1st section*/}
          <div className="first_part">
            <Row>
              <Col lg={4} md={4} sm={12}>
                <h3 className="mt-2"> {t("1 Personal data")}</h3>
              </Col>
              <Col lg={4} md={4} sm={12}>
                <p>{t("SO 11 (2019-11-18)")}</p>
              </Col>
            </Row>
          </div>

          <div className="ml-2 mr-2">
            <Row>
              <InputGroup>
                <Col lg={4} md={4} sm={12}>
                  <label className="common_label">
                    {t("Employee's last name")}
                  </label>
                </Col>

                <Col lg={4} md={4} sm={12}>
                  <label className="common_label">{t("First name")}</label>
                </Col>

                <Col lg={4} md={4} sm={12}>
                  <label className="common_label">
                    {t("Social security number (12 digits)")}
                  </label>
                </Col>
              </InputGroup>
            </Row>
          </div>

          <div className="ml-2 mr-2 border border-dark p-2">
            <Row>
              <InputGroup>
                <Col className="first_remove" lg={4} md={4} sm={12}>
                  <Form.Control
                    type="text"
                    value={pdfDownloadData?.lastName}
                    disabled
                  />
                </Col>
                <Col className="first_remove" lg={4} md={4} sm={12}>
                  <Form.Control value={pdfDownloadData?.firstName} disabled />
                </Col>
                <Col lg={4} md={4} sm={12}>
                  <Form.Control
                    value={pdfDownloadData?.socialSecurityNumber}
                    disabled
                  />
                </Col>
              </InputGroup>
            </Row>
          </div>

          {/* 2nd Section */}
          <div className="mt-3">
            <Row>
              <Col lg={12} md={12} sm={12}>
                <h3>{t("2 Details of employment")}</h3>
              </Col>
            </Row>
          </div>

          <div className="ml-2 mr-2 border border-dark p-2">
            <Row>
              <InputGroup>
                <Col lg={3} md={3} sm={12}>
                  <label className="common_label">
                    {t("Employment period from")}
                  </label>
                </Col>
                <Col lg={3} md={3} sm={12}>
                  <Form.Control
                    type="date"
                    value={pdfDownloadData?.employmentPeriodFrom?.split("T")[0]}
                    disabled
                  />
                </Col>
                <Col lg={1} md={1} sm={6}>
                  <label className="common_label">{t("End Date")}</label>
                </Col>

                <Col lg={3} md={3} sm={6}>
                  <Form.Control
                    type="date"
                    value={pdfDownloadData?.employmentPeriodEnd?.split("T")[0]}
                    disabled
                  />
                </Col>
                <Col lg={2} md={2} sm={12}>
                  <label className="common_label">
                    <Form.Check
                      type="checkbox"
                      checked={pdfDownloadData?.isStillEmployed}
                    />
                    {t("still employed")}
                  </label>
                </Col>
              </InputGroup>

              <InputGroup className="mt-2">
                <Col lg={3} md={3} sm={12}>
                  <label className="common_label">
                    {t("Position (employed as)")}
                  </label>
                </Col>
                <Col lg={7} md={7} sm={12}>
                  <Form.Control
                    placeholder={t("Freelancer")}
                    value={t(pdfDownloadData?.employeePosition)}
                    disabled
                  />
                </Col>

                <Col lg={2} md={2} sm={12}>
                  <label className="common_label">{t("Extent in %")}</label>
                </Col>
              </InputGroup>

              <InputGroup className="mt-2">
                <Col lg={3} md={3} sm={12}>
                  <label className="common_label">
                    {t("Leave of absence from")}
                  </label>
                </Col>
                <Col lg={3} md={3} sm={12}>
                  <Form.Control
                    type="date"
                    value={pdfDownloadData?.leaveAbsenceFrom?.split("T")[0]}
                    disabled
                  />
                </Col>
                <Col lg={1} md={1} sm={6}>
                  <label className="common_label">{t("End Date")}</label>
                </Col>
                <Col lg={3} md={3} sm={6}>
                  <Form.Control
                    type="date"
                    value={pdfDownloadData?.leaveAbsenceEnd?.split("T")[0]}
                    disabled
                  />
                </Col>

                <Col lg={2} md={2} sm={12}>
                  <Form.Control disabled value={pdfDownloadData?.extendsIn} />
                </Col>
              </InputGroup>
            </Row>
          </div>

          {/* 3rd Section */}

          {/* 4th Section */}
          <div className="mt-3">
            <Row>
              <Col lg={12} md={12} sm={12}>
                <h3>{t("3 Working hours")}</h3>
              </Col>
            </Row>
          </div>

          <div className="ml-2 mr-2 border border-dark p-2">
            <Row>
              <InputGroup>
                <Col lg={4} md={4} sm={12}>
                  <label className="common_label">
                    <Form.Check
                      type="checkbox"
                      label={t("Full-time - enter hours per week")}
                      checked={pdfDownloadData?.isFullTimehoursPerWeek}
                    />
                  </label>
                </Col>
                <Col lg={4} md={4} sm={12}>
                  <Form.Control
                    type="number"
                    value={pdfDownloadData?.fullTimehoursPerWeek}
                    disabled
                  />
                </Col>
              </InputGroup>

              <InputGroup className="mt-2">
                <Col lg={3} md={3} sm={12}>
                  <label className="common_label">
                    <Form.Check
                      type="checkbox"
                      label={t("Part-time - enter hours per week")}
                      checked={pdfDownloadData?.isPartTimehoursPerWeek}
                      style={{ accentColor: "#6e56da" }}
                    />
                  </label>
                </Col>
                <Col lg={3} md={3} sm={12}>
                  <Form.Control
                    type="number"
                    placeholder={t("Part time hours per week")}
                    value={pdfDownloadData?.partTimehoursPerWeek}
                    disabled
                  />
                </Col>

                <Col lg={1} md={1} sm={12}>
                  <label className="common_label">{t("Which makes")}</label>
                </Col>

                <Col lg={3} md={3} sm={12}>
                  <Form.Control
                    type="number"
                    value={pdfDownloadData?.percentageFullTimeEmployement}
                    disabled
                  />
                </Col>

                <Col lg={2} md={2} sm={12}>
                  <label className="common_label">
                    {t("% of full-time employment")}
                  </label>
                </Col>
              </InputGroup>

              <Col lg={12} md={12} sm={12}>
                <label className="common_label">
                  <Form.Check
                    type="checkbox"
                    label={t(
                      "Varying working hours (e.g. intermittent employment,' employment' or similar)"
                    )}
                    checked={pdfDownloadData?.isVaryingHours}
                  />
                </label>
              </Col>
            </Row>
          </div>

          {/* 5th Section */}
          <div className="mt-3">
            <Row>
              <Col lg={12} md={12} sm={12}>
                <h3>{t("4 Special information about the employment")}</h3>
              </Col>
            </Row>
          </div>

          <div className="ml-2 mr-2 border border-dark p-2">
            <Row>
              <InputGroup>
                <Col lg={6} md={6} sm={12}>
                  <label className="common_label">
                    {t("Employed by the employment agency for rental")}
                  </label>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <InputGroup>
                    <Form.Check
                      className="common_label pl-4"
                      type="checkbox"
                      label={t("Yes")}
                      checked={pdfDownloadData?.specialInfoEmployment === true}
                      style={{ accentColor: "#6e56da" }}
                    />
                    <label className="ml-2 common_label">{t("No")}</label>
                    <Form.Check
                      className="common_label pl-4"
                      type="checkbox"
                      checked={pdfDownloadData?.specialInfoEmployment === false}
                      style={{ accentColor: "#6e56da" }}
                    />
                  </InputGroup>
                </Col>
              </InputGroup>
            </Row>
          </div>

          {/* 6th Section */}
          <div className="mt-3">
            <Row>
              <Col lg={12} md={12} sm={12}>
                <h3>
                  {t(
                    "5 Reason why the employment has ended in whole or in part"
                  )}
                </h3>
              </Col>
            </Row>
          </div>

          <div className="ml-2 mr-2 border border-dark p-2">
            <Row>
              <Col lg={12} md={12} sm={12}>
                <label className="common_label">
                  <Form.Check
                    type="checkbox"
                    label={t("The employee's own request")}
                    checked={pdfDownloadData?.employeeOwnRequest === true}
                    style={{ accentColor: "#6e56da" }}
                  />
                </label>
              </Col>

              <InputGroup className="mt-2">
                <Col lg={3} md={3} sm={12}>
                  <label className="common_label">
                    <Form.Check
                      type="checkbox"
                      label={t("Other reason - state what")}
                      checked={pdfDownloadData?.isOtherReason === true}
                      style={{ accentColor: "#6e56da" }}
                    />
                  </label>
                </Col>
                <Col lg={9} md={9} sm={12}>
                  <Form.Control
                    type="text"
                    value={pdfDownloadData?.otherReason}
                    disabled
                  />
                </Col>
              </InputGroup>
            </Row>
          </div>

          {/* Seven Section */}
          <div className="mt-3">
            <Row>
              <Col lg={12} md={12} sm={12}>
                <h3>{t("6 Compensation due to termination of employment")}</h3>
              </Col>
            </Row>
          </div>

          <div className="ml-2 mr-2 border border-dark p-2">
            <Row>
              <InputGroup>
                <Col lg={6} md={6} sm={12}>
                  <label className="common_label">
                    {t(
                      "Has an agreement on severance pay or other compensation been entered into"
                    )}
                  </label>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <InputGroup>
                    <Form.Check
                      className="common_label pl-4"
                      type="checkbox"
                      label={t("Yes")}
                      checked={
                        pdfDownloadData?.isCompensationTermination === true
                      }
                      style={{ accentColor: "#6e56da" }}
                    />
                    <label className="ml-2 common_label">{t("No")}</label>
                    <Form.Check
                      className="common_label pl-4"
                      type="checkbox"
                      checked={
                        pdfDownloadData?.isCompensationTermination === false
                      }
                      style={{ accentColor: "#6e56da" }}
                    />
                  </InputGroup>
                </Col>
              </InputGroup>
            </Row>
          </div>

          {/* Eighth Section */}
          <div className="mt-3">
            <Row>
              <Col lg={12} md={12} sm={12}>
                <h3>{t("7 Offer of continued work")}</h3>
              </Col>
            </Row>
          </div>

          <div className="ml-2 mr-2 border border-dark p-2">
            <Row>
              <InputGroup>
                <Col lg={2} md={2} sm={12}>
                  <InputGroup>
                    <Form.Check
                      type="checkbox"
                      className="common_label pl-4"
                      checked={pdfDownloadData?.isContinueWorkFrom === false}
                      style={{ accentColor: "#6e56da" }}
                      disabled={pdfDownloadData?.isStillEmployed === true}
                    />
                    <Form.Check
                      className="common_label pl-4"
                      label={t("Yes,from")}
                      type="checkbox"
                      checked={pdfDownloadData?.isContinueWorkFrom === true}
                      style={{ accentColor: "#6e56da" }}
                      disabled={pdfDownloadData?.isStillEmployed === true}
                    />
                  </InputGroup>
                </Col>
                <Col lg={3} md={3} sm={12}>
                  <Form.Control
                    type="date"
                    value={pdfDownloadData?.continueWorkFromDate?.split("T")[0]}
                    disabled
                  />
                </Col>
                <Col lg={1} md={1} sm={6}>
                  <label className="common_label">{t("End Date")}</label>
                </Col>
                <Col lg={3} md={3} sm={6}>
                  <Form.Control
                    type="date"
                    value={pdfDownloadData?.continueWorkEndDate?.split("T")[0]}
                    disabled
                  />
                </Col>
                <Col lg={3} md={3} sm={12}>
                  <label className="common_label">
                    <Form.Check
                      type="checkbox"
                      label={t("until further notice")}
                      checked={pdfDownloadData?.isUntilFurtherNotice === true}
                    />
                  </label>
                </Col>
              </InputGroup>

              <InputGroup>
                <Col lg={12} md={12} sm={12}>
                  <label className="common_label">
                    <Form.Check
                      type="checkbox"
                      label={t("Variable working hours (hourly employment)")}
                      checked={
                        pdfDownloadData?.isContinueVariableWorkingHours === true
                      }
                      style={{ accentColor: "#6e56da" }}
                    />
                  </label>
                </Col>
              </InputGroup>
              <Col lg={8} md={8} sm={12}>
                <InputGroup>
                  <label className="common_label">
                    {t("Has the employee accepted?")}
                  </label>
                  <Form.Check
                    className="common_label pl-4"
                    type="checkbox"
                    label={t("Yes")}
                    checked={
                      pdfDownloadData?.isContinueEmployeeAccepted === true
                    }
                    style={{ accentColor: "#6e56da" }}
                  />
                  <label className="ml-2 common_label">{t("No")}</label>
                  <Form.Check
                    className="common_label pl-4"
                    type="checkbox"
                    label={t("state when he/she refused")}
                    checked={
                      pdfDownloadData?.isContinueEmployeeAccepted === true
                    }
                    style={{ accentColor: "#6e56da" }}
                  />
                </InputGroup>
              </Col>
              <Col lg={4} md={4} sm={6}>
                <Form.Control
                  type="date"
                  value={
                    pdfDownloadData?.isContinueEmployeeAcceptedDate?.split(
                      "T"
                    )[0]
                  }
                  disabled
                />
              </Col>
            </Row>
          </div>

          {/* Nine Section */}
          <div className="mt-3">
            <Row>
              <Col lg={12} md={12} sm={12}>
                <h3>
                  {t(
                    "8 The employer's (or representative's) signature - note that the form continues on the next page"
                  )}
                </h3>
              </Col>
            </Row>
          </div>

          <div className="ml-2 mr-2 border border-dark p-2">
            <Row>
              <InputGroup>
                <Col lg={2} md={2} sm={12}>
                  <label className="common_label">{t("Signature")}</label>
                </Col>

                <Col className="first_remove" lg={3} md={3} sm={12}>
                  {!pdfDownloadData?.signature && (
                    <Form.Control type="file" name="signature" />
                  )}
                  {pdfDownloadData?.signature && (
                    <div className="image-preview">
                      <img
                        src={pdfDownloadData?.signature}
                        alt="Signature Preview"
                        className="img-thumbnail"
                      />
                    </div>
                  )}
                </Col>
                <Col lg={2} md={2} sm={12}>
                  <label className="common_label">
                    {t("Name clarification")}
                  </label>
                </Col>
                <Col lg={4} md={4} sm={12}>
                  <Form.Control
                    disabled
                    value={pdfDownloadData?.nameClarification}
                  />
                </Col>
              </InputGroup>
            </Row>
          </div>

          {/* Ten Section */}
          <div className="mt-3">
            <Row>
              <Col lg={12} md={12} sm={12}>
                <h3>{t("9 Personal Identification Number (12 digits)")}</h3>
              </Col>
            </Row>
          </div>

          <div className="ml-2 w-50 mr-2 border border-dark p-2">
            <Row>
              <Col lg={12} md={12} sm={12}>
                <Form.Control
                  value={pdfDownloadData?.socialSecurityNumber}
                  disabled
                />
              </Col>
            </Row>
          </div>

          {/* 11th Section */}
          <div className="mt-3">
            <Row>
              <Col lg={12} md={12} sm={12}>
                <h3>{t("10 Time worked")}</h3>
              </Col>
            </Row>
          </div>

          <div className="ml-2 mr-2 border border-dark p-2">
            <div className="table_wrap d-flex">
              {/* First Table */}
              <Table responsive="lg">
                <thead>
                  <tr>
                    <th>
                      {t("Year")}
                      <Form.Control type="text" value={startDate} />
                    </th>
                    <th>
                      {t("Hours worked")} <br />{" "}
                      {t("(not over-, more- or filling time)")}
                    </th>
                    <th>{t("Absence")}</th>
                    <th>{t("Overtime")}</th>
                    <th>
                      {t("Mertid")} <br />
                      {t("Filling time")}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {firstYearDataTable?.map((month, idx) => (
                    <tr key={idx}>
                      <td>{t(month?.month)}</td>
                      <td>
                        <Form.Control
                          className={`table_rowinput form-control`}
                          value={month.hoursworked}
                        />
                      </td>
                      <td>
                        <Form.Control
                          className={`table_rowinput form-control`}
                          value={month?.absence}
                        />
                      </td>
                      <td>
                        <Form.Control
                          className={`table_rowinput form-control`}
                          value={month?.overtime}
                        />
                      </td>
                      <td>
                        <Form.Control
                          className={`table_rowinput form-control`}
                          value={month?.mertidFillingTime}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {/* Second Table */}
              <Table responsive="lg">
                <thead>
                  <tr>
                    <th>
                      {t("Year")}
                      <Form.Control type="text" value={endDate} />
                    </th>
                    <th>
                      {t("Hours worked")} <br />{" "}
                      {t("(not over-, more- or filling time)")}
                    </th>
                    <th>{t("Absence")}</th>
                    <th>{t("Overtime")}</th>
                    <th>
                      {t("Mertid")} <br />
                      {t("Filling time")}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {secondYearDataTable?.map((month, idx) => (
                    <tr key={idx}>
                      <td>{t(month?.month)}</td>
                      <td>
                        <Form.Control
                          className={`table_rowinput form-control`}
                          value={month?.hoursworked}
                        />
                      </td>
                      <td>
                        <Form.Control
                          className={`table_rowinput form-control`}
                          value={month?.absence}
                        />
                      </td>
                      <td>
                        <Form.Control
                          className={`table_rowinput form-control`}
                          value={month?.overtime}
                        />
                      </td>
                      <td>
                        <Form.Control
                          className={`table_rowinput form-control`}
                          value={month?.mertidFillingTime}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <Row className="mt-2">
              <InputGroup>
                <div className="d-flex">
                  <Col lg={9} md={9} sm={12}>
                    <label className="common_label">
                      {t(
                        "The working time above has been stated in teaching hours"
                      )}
                      <Form.Check
                        className="common_label pl-4"
                        type="radio"
                        label={t("No")}
                        checked={pdfDownloadData?.isTeachingHours === true}
                        style={{ accentColor: "#6e56da" }}
                      />
                      <Form.Check
                        name="selected_hours"
                        className="common_label pl-4"
                        type="radio"
                        label={t("Yes")}
                        checked={pdfDownloadData?.isTeachingHours === true}
                        style={{ accentColor: "#6e56da" }}
                      />
                      {t(
                        "If yes, enter the full-time measure of teaching hours/week"
                      )}
                    </label>
                  </Col>
                </div>

                <Col lg={3} md={3} sm={12}>
                  <Form.Control
                    value={pdfDownloadData?.teachingHours}
                    disabled
                  />
                </Col>
              </InputGroup>
              <label className="common_label ml-3">
                {t(
                  "If the work concerns artistic work, the number of days worked in each month must also be entered in the field for worked days on the form 'Supplementing to employer's certificate'."
                )}
              </label>
            </Row>
          </div>

          {/* Twelth Section */}
          <div className="mt-3">
            <Row>
              <Col lg={12} md={12} sm={12}>
                <h3>{t("11 Information about the salary")}</h3>
              </Col>
            </Row>
          </div>

          <div className="ml-2 mr-2 border border-dark p-2">
            <Row>
              <InputGroup>
                <Col lg={2} md={2} sm={12}>
                  <label className="common_label">
                    {t("Salary refers to years")}
                  </label>
                </Col>
                <Col className="mb-2" lg={3} md={3} sm={12}>
                  <Form.Control
                    type="text"
                    value={referYear}
                    style={{ width: 100 }}
                    disabled
                  />
                </Col>

                <Col lg={7} md={7} sm={12}>
                  <InputGroup>
                    <Form.Check
                      className="common_label"
                      type="checkbox"
                      label={t("Monthly Salary")}
                      checked={pdfDownloadData?.isMonthlySalary === true}
                      style={{ accentColor: "#6e56da" }}
                    />
                    <Form.Check
                      className="common_label pl-4"
                      type="checkbox"
                      label={t("Weekly salary")}
                      checked={pdfDownloadData?.isWeeklySalary === true}
                      style={{ accentColor: "#6e56da" }}
                    />
                    <Form.Check
                      className="common_label pl-4"
                      type="checkbox"
                      label={t("Daily salary")}
                      checked={pdfDownloadData?.isDalilySalary === true}
                      style={{ accentColor: "#6e56da" }}
                    />
                    <Form.Check
                      className="common_label pl-4"
                      type="checkbox"
                      label={t("Hourly salary")}
                      checked={pdfDownloadData?.isHourlySalary === true}
                      style={{ accentColor: "#6e56da" }}
                    />
                  </InputGroup>
                </Col>

                <Col lg={8} md={8} sm={6}>
                  <Form.Control
                    value={pdfDownloadData?.amountForOverTime}
                    disabled
                  />
                </Col>

                <Col lg={4} md={4} sm={12}>
                  <label className="common_label">{t("Amount in SEK")}</label>
                </Col>
              </InputGroup>
              <label className="common_label">
                {t("Has the hourly wage for overtime,")}
              </label>
              <label className="common_label">
                {t("overtime or fill-in work varied?")}

                <Form.Check
                  className="common_label pl-4"
                  type="radio"
                  label={t("No - report that hourly salary above")}
                  checked={pdfDownloadData?.isFillingWorkvaried}
                  style={{ accentColor: "#6e56da" }}
                />
                <Form.Check
                  className="common_label pl-4"
                  type="radio"
                  label={t(
                    "Yes - Report that salary month by month on the form Completion to employer's certificate"
                  )}
                  checked={pdfDownloadData?.isFillingWorkvaried === true}
                  style={{ accentColor: "#6e56da" }}
                />
              </label>

              <InputGroup className="mt-2">
                <Col lg={1} md={1} sm={12}>
                  <label className="common_label">{t("Overtime, enter")}</label>
                </Col>
                <Col lg={3} md={3} sm={12}>
                  <Form.Control
                    value={pdfDownloadData?.overTimeHours}
                    disabled
                  />
                </Col>
                <Col lg={3} md={3} sm={12}>
                  <label className="common_label">
                    {t("SEK/hour Mertid/filling time, enter")}
                  </label>
                </Col>
                <Col lg={3} md={3} sm={12}>
                  <Form.Control
                    value={pdfDownloadData?.hoursMertidFilllingTime}
                    disabled
                  />
                </Col>
                <Col lg={1} md={1} sm={12}>
                  <label className="common_label">{t("SEK/hour")}</label>
                </Col>
              </InputGroup>
              <label className="common_label">
                {t(
                  "Salary in addition to the monthly, weekly, daily or hourly salary (e.g. on-call or OB compensation, gage etc.)"
                )}
                <Form.Check
                  className="common_label pl-4"
                  type="radio"
                  label={t("No")}
                  checked={pdfDownloadData?.isSalaryInAdditional === true}
                  style={{ accentColor: "#6e56da" }}
                />
                <Form.Check
                  className="common_label pl-4"
                  type="radio"
                  label={t("Yes")}
                  checked={pdfDownloadData?.isSalaryInAdditional === true}
                  style={{ accentColor: "#6e56da" }}
                />
                {t(
                  "Report that salary month by the form 'Supplement to employer's certificate' month on and other taxable compensation that is not included in the salary stated above?"
                )}
              </label>
            </Row>
          </div>

          {/* Thirteen Section */}
          <div className="mt-3">
            <Row>
              <Col lg={12} md={12} sm={12}>
                <h3>
                  {t(
                    "12 Residency pay and holiday pay (only for study-related activities)"
                  )}
                </h3>
              </Col>
            </Row>
          </div>

          <div className="ml-2 mr-2 border border-dark p-2">
            <Row>
              <InputGroup>
                <Col lg={6} md={6} sm={12}>
                  <label className="common_label d-flex">
                    {t("Employee with holiday pay")}
                    <Form.Check
                      className="pr-2"
                      type="radio"
                      label={t("No")}
                      checked={pdfDownloadData?.isEmployeeWithHoliday === true}
                      style={{ accentColor: "#6e56da" }}
                    />
                    <Form.Check
                      type="radio"
                      label={t("Yes")}
                      checked={pdfDownloadData?.isEmployeeWithHoliday === true}
                      style={{ accentColor: "#6e56da" }}
                    />{" "}
                    {t("If yes, enter the number of paid holiday days")}
                  </label>
                </Col>
                <Col lg={3} md={3} sm={12}>
                  <Form.Control
                    value={pdfDownloadData?.numberOfPaidHoliday}
                    disabled
                  />
                </Col>
                <Col lg={3} md={3} sm={6}>
                  <label className="common_label">
                    {t("Enter paid holiday pay in SEK")}
                  </label>
                </Col>
                <Col lg={4} md={4} sm={6}>
                  <Form.Control
                    value={pdfDownloadData?.holidayPayInKroner}
                    disabled
                  />
                </Col>
              </InputGroup>

              <InputGroup className="mt-2">
                <Col lg={8} md={8} sm={12}>
                  <label className="common_label d-flex">
                    {t("Employee with living wage")}
                    <Form.Check
                      className="pr-2"
                      type="radio"
                      label={t("No")}
                      checked={
                        pdfDownloadData?.isEmployeeWithLivingWage === true
                      }
                      style={{ accentColor: "#6e56da" }}
                    />
                    <Form.Check
                      type="radio"
                      label={t("Yes")}
                      checked={
                        pdfDownloadData?.isEmployeeWithLivingWage === true
                      }
                      style={{ accentColor: "#6e56da" }}
                    />{" "}
                    {t("If yes, enter earned living wage in SEK")}
                  </label>

                  <label className="common_label"></label>
                </Col>
                <Col lg={4} md={4} sm={12}>
                  <Form.Control
                    value={pdfDownloadData?.earnedLivingWage}
                    disabled
                  />
                </Col>
              </InputGroup>
            </Row>
          </div>

          {/* 14th Section */}
          <div className="mt-3">
            <Row>
              <Col lg={12} md={12} sm={12}>
                <h3>{t("13 Other information")}</h3>
              </Col>
            </Row>
          </div>

          <div className="ml-2 mr-2 border border-dark p-2">
            <Row>
              <InputGroup>
                <Col lg={6} md={6} sm={12}>
                  <label className="common_label">
                    {t("See appendix 'Other information'.")}
                  </label>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Control
                    value={pdfDownloadData?.otherInformation}
                    disabled
                  />
                </Col>
              </InputGroup>
            </Row>
          </div>

          {/* 15th Section */}
          <div className="mt-3">
            <Row>
              <Col lg={12} md={12} sm={12}>
                <h3>
                  {t("14 The employer's (or representative's) signature")}
                </h3>
              </Col>
            </Row>
          </div>

          <div className="ml-2 mr-2 border border-dark p-2">
            <Row>
              <InputGroup>
                <Col lg={6} md={6} sm={12}>
                  <label className="common_label">
                    {t("The employers name and address")}
                  </label>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Control
                    type="text"
                    name="employersNameAndAddress"
                    className={`remove_border form-contro`}
                    placeholder={t("Invozio LV SIA, AHTRI 12, 10151 Tallinn")}
                    value={"Invozio LV SIA, AHTRI 12, 10151 Tallinn"}
                    disabled
                  />
                </Col>
              </InputGroup>

              <InputGroup>
                <Col lg={6} md={6} sm={12}>
                  <label className="common_label">
                    {t("Organization number")}
                  </label>
                </Col>
                <Col className="mt-2" lg={6} md={6} sm={12}>
                  <Form.Control
                    className={`remove_border form-control`}
                    value="50 20 85 40 62"
                    placeholder={t("5 0 2 0 8 5 4 0 6 2")}
                    disabled
                  />
                </Col>
              </InputGroup>

              <InputGroup>
                <Col lg={3} md={3} sm={12}>
                  <label className="common_label">{t("Date")}</label>
                </Col>

                <Col lg={3} md={3} sm={12}>
                  <label className="common_label">{t("Signature")}</label>
                </Col>

                <Col lg={3} md={3} sm={12}>
                  <label className="common_label">
                    {t("Name clarification")}
                  </label>
                </Col>
              </InputGroup>

              <div className="ml-2 mr-2 border border-dark p-2">
                <InputGroup>
                  <Col className="first_remove" lg={3} md={3} sm={12}>
                    <Form.Control
                      type="date"
                      value={pdfDownloadData?.employersDate?.split("T")[0]}
                      disabled
                    />
                  </Col>

                  <Col className="first_remove" lg={6} md={6} sm={12}>
                    {!pdfDownloadData?.signature && (
                      <Form.Control
                        type="file"
                        name="signature"
                        value={pdfDownloadData?.signature}
                        disabled
                      />
                    )}
                    {pdfDownloadData?.signature && (
                      <div className="image-preview">
                        <img
                          src={pdfDownloadData?.signature}
                          alt="employersSignature Preview"
                          className="img-thumbnail"
                        />
                      </div>
                    )}
                  </Col>

                  <Col className="first_remove" lg={3} md={3} sm={12}>
                    <Form.Control
                      value={pdfDownloadData?.nameClarification}
                      disabled
                    />
                  </Col>
                </InputGroup>
              </div>
            </Row>
          </div>

          {/* INSTRUCTIONS FOR THE EMPLOYER'S CERTIFICATE 2019-11-18 */}
          <div className="ml-2 mr-2 p-2">
            <h3>
              {t("INSTRUCTIONS FOR THE EMPLOYER'S CERTIFICATE 2019-11-18")}
            </h3>
            <p className="common_label">
              {t(
                "The form is determined by the IAF (Inspektionen för Arbetslöhetsförsäkringen) and drawn up in consultation with Sweden's unemployment insurance funds. The employer must issue an employer's certificate on request (section 47 of the Act (1997:238) on unemployment insurance)."
              )}
            </p>
            <p className="common_label">
              {t(
                "The employer's certificate is needed - when an employee applies for unemployment benefits - when an employee seeks activity support The information provided in the certificate may be insufficient to assess the right to compensation. The employer may therefore need to provide additional information to the unemployment fund."
              )}
            </p>
            <p className="common_label">
              {t(
                "Employer certificates shall not be issued to persons whose work has been financed with special employment support, e.g. entry level job. For other forms of employment support, an employer's certificate must be issued. This applies, for example, to wage subsidy employment, start-up jobs and OSA."
              )}
            </p>
            <p className="common_label">
              {t(
                "Special certificates are available, for example, for employees who are employed in their own business."
              )}
            </p>

            <p className="common_label">
              {t(
                "The form must be machine-readable. Therefore, please fill in the form on the computer."
              )}
            </p>
            <p className="common_label">
              {t(
                "If the information is filled in by hand, it is important that the information is filled in correctly. Use a ballpoint pen with blue or black writing. Please text. Write within the marked frames:"
              )}
            </p>
          </div>

          {/* 16th Section */}
          <div className="ml-2 mr-2 border border-dark p-2">
            <Row>
              <InputGroup>
                <Col lg={2} md={2} sm={12}>
                  <label className="common_label">
                    {t("Write within the marked boxes:")}
                  </label>
                </Col>

                <Col lg={2} md={2} sm={12}>
                  <label className="common_label">{t("Right:")}</label>
                </Col>
                <Col lg={3} md={3} sm={12}>
                  <Form.Control
                    value={pdfDownloadData?.writeWithinMarkedBoxRight}
                    disabled
                  />
                </Col>

                <Col lg={2} md={2} sm={6}>
                  <label className="common_label">{t("Wrong:")}</label>
                </Col>

                <Col lg={3} md={3} sm={6}>
                  <Form.Control
                    value={pdfDownloadData?.writeWithinMarkedWrong}
                    disabled
                  />
                </Col>
              </InputGroup>

              <InputGroup className="mt-2 mb-2">
                <Col lg={4} md={4} sm={6}>
                  <label className="common_label">
                    {t("Use cross instead of 'tick':")}
                  </label>
                </Col>

                <Col lg={2} md={2} sm={12}>
                  <Form.Check
                    className="pr-2"
                    type="radio"
                    label={t("Yes")}
                    checked={pdfDownloadData?.isCrossInstedofTick === true}
                    style={{ accentColor: "#6e56da" }}
                  />
                </Col>
                <Col lg={2} md={2} sm={12}>
                  <Form.Check
                    className="pr-2"
                    type="radio"
                    label={t("No")}
                    checked={pdfDownloadData?.isCrossInstedofTick === true}
                    style={{ accentColor: "#6e56da" }}
                  />
                </Col>
              </InputGroup>

              <InputGroup>
                <Col lg={6} md={6} sm={12}>
                  <label className="common_label">
                    {t(
                      "If you ticked incorrectly - fill in the entire checkbox:"
                    )}
                  </label>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <label className="common_label d-flex">
                    {t("Correctly filled in:")}
                    <Form.Check
                      className="pr-2 ml-4"
                      type="radio"
                      checked={pdfDownloadData?.isTickInCorrectly === true}
                      style={{ accentColor: "#6e56da" }}
                    />
                    <Form.Check
                      type="radio"
                      label={t("Incorrectly filled in:")}
                      checked={pdfDownloadData?.isTickInCorrectly === true}
                      style={{ accentColor: "#6e56da" }}
                    />
                  </label>
                </Col>
              </InputGroup>

              <InputGroup>
                <Col lg={6} md={6} sm={12}>
                  <label className="common_label">
                    {t("Write numbers like this:")}
                  </label>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Control
                    value={pdfDownloadData?.writeNumberLike}
                    disabled
                  />
                </Col>
              </InputGroup>

              <InputGroup className="mt-2">
                <Col lg={6} md={6} sm={12}>
                  <label className="common_label">
                    {t(
                      "The date is filled in according to the formula YYYYMMDD:"
                    )}
                  </label>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Control
                    type="date"
                    value={pdfDownloadData?.formulaDate?.split("T")[0]}
                    disabled
                  />
                </Col>
              </InputGroup>
            </Row>
          </div>

          <div className="ml-2 mr-2 p-2">
            <Row>
              <Col lg={6} md={6} sm={12}>
                {empCertificateLeft?.map((con, idx) => (
                  <div key={idx}>
                    <h6 className="content_head">{t(con?.title) || ""}</h6>
                    <p className="content_para">{t(con?.description) || ""}</p>
                    <p className="content_para">{t(con?.subtitle) || ""}</p>
                    <p className="content_para">
                      {t(con?.sub_description1) || ""}
                    </p>
                    <p className="content_para">
                      {t(con?.sub_description2) || ""}
                    </p>
                    <p className="content_para">{t(con?.other_des) || ""}</p>
                  </div>
                ))}
              </Col>

              <Col lg={6} md={6} sm={12}>
                {empCertificateRight?.map((content, idx) => (
                  <div key={idx}>
                    <h6 className="content_head">{t(content?.title) || ""}</h6>
                    <p className="content_para">
                      {t(content?.description) || ""}
                    </p>
                    <p className="content_para">{t(content?.subtitle) || ""}</p>
                    <p className="content_para">
                      {t(content?.sub_description1) || ""}
                    </p>
                    <p className="content_para">
                      {t(content?.sub_description2) || ""}
                    </p>
                    <p className="content_para">
                      {t(content?.other_des) || ""}
                    </p>
                  </div>
                ))}
              </Col>
            </Row>

            <Row>
              <Col lg={12} md={12} sm={12}>
                <h6 className="content_head">
                  {t("Note")}: {t("Supplement to Employer Certificate")}
                </h6>
                <h6 className="content_head">
                  {t(
                    "ATTENTION! This supplement should only be filled in and sent if necessary!"
                  )}
                </h6>
                <p className="content_para">
                  {t(
                    "Compensation that is not stated on the main form 'Employer's certificate' must be entered here. Only remuneration that is taxed as income from service shallbrought up."
                  ) || ""}
                </p>
              </Col>
            </Row>
          </div>

          <div className="mb-4 p-2">
            <p>{t("2 Remuneration taxed as income from service")}</p>
            <Table responsive="lg">
              <thead>
                <tr>
                  <th>
                    {t("Year month")} <br /> {t("(MM/YYYY)")}
                  </th>
                  <th>{t("Number of days worked")}</th>
                  <th>{t("Duty etc. Hours")}</th>
                  <th>{t("SEK/month")}</th>
                  <th>{t("Other compensation Enter species")}</th>
                  <th>{t("SEK/month")}</th>
                </tr>
              </thead>

              <tbody>
                {incomeServiceFields
                  ?.filter(
                    (incomeService) =>
                      Object.values(incomeService).some(
                        (val) => val !== "" && val !== undefined && val !== null
                      )
                  )
                  .map((incomeService, idx) => (
                    <tr key={idx}>
                      <td>
                        <th style={{ border: "none" }}>
                          <Form.Control
                            type="text"
                            value={
                              incomeService?.monthdate
                                ? formatMonthYear(incomeService.monthdate)
                                : ""
                            }
                            style={{ width: 100 }}
                          />
                        </th>
                      </td>
                      <td>
                        <Form.Control
                          className={`table_rowinput form-control`}
                          value={incomeService?.numberOfDaysWorked}
                        />
                      </td>
                      <td>
                        <Form.Control 
                          className={`table_rowinput form-control`}
                          value={incomeService?.dutyHours}
                        />
                      </td>
                      <td>
                        <Form.Control
                          className={`table_rowinput form-control`}
                          value={incomeService?.nOKMonth}
                        />
                      </td>
                      <td>
                        <Form.Control
                          className={`table_rowinput form-control`}
                          value={incomeService?.otherRemunerationEnterArt}
                        />
                      </td>

                    <td>
                      <Form.Control
                        className={`table_rowinput form-control`}
                        value={incomeService?.nokMonthAmount}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          <div className="d-flex w-100">
            <div className="ml-2 w-50 mr-2 border border-dark rounded p-2">
              <Row>
                <Col lg={12} md={12} sm={12}>
                  <label className="common_label">
                    {t(" 1 Information about person and employer")}
                  </label>
                </Col>
                <InputGroup className="other_info_col">
                  <Col className="mt-2" lg={6} md={6} sm={12}>
                    <label className="common_label">
                      {t("Employee Name:")}
                    </label>
                  </Col>

                  <Col lg={6} md={6} sm={12}>
                    <Form.Control value={pdfDownloadData?.userName} disabled />
                  </Col>
                </InputGroup>

                <InputGroup className="other_info_col">
                  <Col className="mt-2" lg={6} md={6} sm={12}>
                    <label className="common_label">
                      {t("Employer name:")}
                    </label>
                  </Col>

                  <Col lg={6} md={6} sm={12}>
                    <Form.Control
                      value={pdfDownloadData?.employerName}
                      disabled
                    />
                  </Col>
                </InputGroup>

                <InputGroup className="other_info_col">
                  <Col className="mt-2" lg={6} md={6} sm={12}>
                    <label className="common_label">
                      {t("Street address:")}
                    </label>
                  </Col>

                  <Col lg={6} md={6} sm={12}>
                    <Form.Control
                      value={pdfDownloadData?.streetAddress}
                      disabled
                    />
                  </Col>
                </InputGroup>

                <InputGroup className="other_info_col">
                  <Col className="mt-2" lg={6} md={6} sm={12}>
                    <label className="common_label">
                      {t("Mailing address:")}
                    </label>
                  </Col>

                  <Col lg={6} md={6} sm={12}>
                    <Form.Control
                      value={pdfDownloadData?.mailingAddress}
                      disabled
                    />
                  </Col>
                </InputGroup>

                <InputGroup className="other_info_col">
                  <Col className="mt-2" lg={6} md={6} sm={12}>
                    <label className="common_label">
                      {t("Organization number:")}
                    </label>
                  </Col>

                  <Col lg={6} md={6} sm={12}>
                    <Form.Control
                      value={pdfDownloadData?.organizationNumber}
                      disabled
                    />
                  </Col>
                </InputGroup>

                <InputGroup className="other_info_col">
                  <Col className="mt-2" lg={6} md={6} sm={12}>
                    <label className="common_label">
                      {t("Telephone number of the informant:")}
                    </label>
                  </Col>

                  <Col lg={6} md={6} sm={12}>
                    <Form.Control
                      value={pdfDownloadData?.telephoneNumber}
                      disabled
                    />
                  </Col>
                </InputGroup>
              </Row>
            </div>

            <div className="ml-2 mr-2 w-50 p-2">
              <Row className="left_info">
                <Col lg={12} md={12} sm={12}>
                  <label className="common_label">
                    {t("Social security number (12 digits)")}
                  </label>
                </Col>
                <Col lg={12} md={12} sm={12}>
                  <Form.Control
                    value={pdfDownloadData?.socialSecurityNumber}
                    disabled
                  />
                </Col>
              </Row>
            </div>
          </div>

          <div className="m-2 border border-dark rounded p-2">
            <Row>
              <Col lg={12} md={12} sm={12}>
                <label className="common_label">
                  {t("2 Other information")}
                </label>
              </Col>
              <InputGroup>
                <Col lg={12} md={12} sm={12}>
                  {t("2. Details of the employment")}
                  <Form.Control
                    as="textarea"
                    value={pdfDownloadData?.otherInfomationEmployment}
                    disabled
                  />
                </Col>
              </InputGroup>
            </Row>
          </div>

          <div className="ml-2 mr-2">
            <Row>
              {t("3 The employer's (or representative's) signature")}
              <InputGroup>
                <Col lg={3} md={3} sm={12}>
                  <label className="common_label">{t("Date")}</label>
                </Col>

                <Col lg={3} md={3} sm={12}>
                  <label className="common_label">{t("City")}</label>
                </Col>

                <Col lg={3} md={3} sm={12}>
                  <label className="common_label">{t("Signature")}</label>
                </Col>
                <Col lg={3} md={3} sm={12}>
                  <label className="common_label">
                    {t("Name clarification")}
                  </label>
                </Col>
              </InputGroup>
            </Row>
          </div>

          <div className="ml-2 mr-2 border border-dark p-2">
            <Row>
              <InputGroup>
                <Col className="first_remove" lg={3} md={3} sm={12}>
                  <Form.Control
                    disabled
                    type="date"
                    value={pdfDownloadData?.employersDate?.split("T")[0]}
                  />
                </Col>
                <Col className="first_remove" lg={3} md={3} sm={12}>
                  <Form.Control
                    disabled
                    value={pdfDownloadData?.representativeCity}
                  />
                </Col>

                <Col className="first_remove" lg={3} md={3} sm={12}>
                  {!pdfDownloadData?.signature && (
                    <Form.Control type="file" name="signature" />
                  )}
                  {pdfDownloadData?.signature && (
                    <div className="image-preview">
                      <img
                        src={pdfDownloadData?.signature}
                        alt="Signature Preview"
                        className="img-thumbnail"
                      />
                    </div>
                  )}
                </Col>

                <Col lg={3} md={3} sm={12}>
                  <Form.Control
                    disabled
                    value={pdfDownloadData?.nameClarification}
                  />
                </Col>
              </InputGroup>
            </Row>
          </div>
        </div>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              settoggleDownload(false);
            }}
          >
            {t("Cancel")}
          </Button>

                     <select
                          value={selectedLanguage}
                          onChange={e => setSelectedLanguage(e.target.value)}
                          style={{
                            color: '#664fb9',
                            fontWeight: 500,
                            padding: '0 12px',
                            minWidth: '110px',
                            cursor: 'pointer',
                            height: '38px',
                            borderRadius: '4px 0px 0px 4px',
                            marginRight: '-4px',
                          }}
                        >
                          <option value="sv-se">Swedish</option>
                          <option value="en-us">English</option>
                        </select>
          <Button
            disabled={isLoading}
            onClick={handleDownloadPDF}
            type="submit"
            variant="primary"
            style={{borderRadius: "0px 4px 4px 0px"}}
          >
            {t("Download")}
          </Button>
        </Modal.Footer>
       
      </Modal>
       )}
    </React.Fragment>
  );
};

export default memo(DownloadCertificateModal);
